import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';
import HomeScreen from "./screens/HomeScreen.js";
import ProductScreen from './screens/ProductScreen.js';
import Container from 'react-bootstrap/Container';
import { LinkContainer } from 'react-router-bootstrap';
import Badge from 'react-bootstrap/Badge';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import { useContext, useEffect, useState } from 'react';
import { Store } from './Store.js';
import CartScreen from './screens/CartScreen.js';
import SigninScreen from './screens/SigninScreen.js';
import SignupScreen from './screens/SignupScreen.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ShippingAddressScreen from './screens/ShippingAddressScreen.js';
import PaymentMethodScreen from './screens/PaymentMethodScreen.js';
import PlaceOrderScreen from './screens/PlaceOrderScreen.js';
import OrderScreen from './screens/OrderScreen.js';
import OrderHistoryScreen from './screens/OrderHistoryScreen.js';
import ProfileScreen from './screens/ProfileScreen.js';
import { Button } from 'react-bootstrap';
import { getError } from './utils.js';
import axios from 'axios';
import SearchBox from './components/SearchBox.js';
import SearchScreen from './screens/SearchScreen.js';
import ProtectedRoute from './components/ProtectedRoute.js';
import DashboardScreen from './screens/DashboardScreen.js';
import AdminRoute from './components/AdminRoute.js';
import ProductListScreen from './screens/ProductListScreen';
import ProductEditScreen from './screens/ProductEditScreen';
import OrderListScreen from './screens/OrderListScreen';

import UserListScreen from './screens/UserListScreen';

import UserEditScreen from './screens/UserEditScreen';


function App() {
    const { state, dispatch: ctxDispatch } = useContext(Store);
    const { cart, userInfo } = state;

    const signoutHandler = () => {
        ctxDispatch({ type: 'USER_SIGNOUT' });
        localStorage.removeItem('userInfo');
        localStorage.removeItem('shippingAddress');
        localStorage.removeItem('paymentMethod');
        window.location.href = '/signin';
    }

    const [sidebarIsOpen, setSideBarIsOpen] = useState(false);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const { data } = await axios.get(`/api/products/categories`);
                setCategories(data);
            } catch (err) {
                toast.error(getError(err));
            }
        }
        fetchCategories();
    }, []);


    return (
        <BrowserRouter>
            <div className={
                sidebarIsOpen
                    ? 'd-flex flex-column site-container active-cont'
                    : 'd-flex flex-column site-container'
            }>

                <ToastContainer position='bottom-center' limit={1} />

                <header>
                    <Navbar bg="dark" variant="dark" expand='lg'  >
                        <Container>
                            <Button
                                variant="dark"
                                onClick={() => setSideBarIsOpen(!sidebarIsOpen)}
                            >
                                <i className="fas fa-bars"></i>
                            </Button>


                            <LinkContainer to="/">
                                <Navbar.Brand>eBuy</Navbar.Brand>
                            </LinkContainer>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />

                            <Navbar.Collapse id="basic-navbar-nav">
                                <SearchBox />
                                <Nav className="me-auto w-100 justify-content-end">
                                    <Link to="/cart" className="nav-link">
                                        Cart
                                        {cart.cartItems.length > 0 && (
                                            <Badge pill bg="danger">
                                                {cart.cartItems.reduce((a, c) => a + c.quantity, 0)}
                                            </Badge>
                                        )}
                                    </Link>
                                    {userInfo ? (
                                        <NavDropdown title={userInfo.name} id="basic-nav-dropdown">
                                            <LinkContainer to="/profile">
                                                <NavDropdown.Item>User Profile</NavDropdown.Item>
                                            </LinkContainer>

                                            <LinkContainer to="/orderhistory">
                                                <NavDropdown.Item>Order History</NavDropdown.Item>
                                            </LinkContainer>

                                            <NavDropdown.Divider />
                                            <Link className="dropdown-item" to="#signout" onClick={signoutHandler}>
                                                Sign Out
                                            </Link>

                                        </NavDropdown>
                                    ) : (
                                        <Link className="nav-link" to="/signin">
                                            Sign In
                                        </Link>
                                    )}
                                    {userInfo && userInfo.isAdmin && (
                                        <NavDropdown title="Admin" id="admin-nav-dropdown">

                                            <LinkContainer to="/admin/dashboard">
                                                <NavDropdown.Item>Dashboard</NavDropdown.Item>
                                            </LinkContainer>

                                            <LinkContainer to="/admin/products">
                                                <NavDropdown.Item>Products</NavDropdown.Item>
                                            </LinkContainer>

                                            <LinkContainer to="/admin/orders">
                                                <NavDropdown.Item>Orders</NavDropdown.Item>
                                            </LinkContainer>

                                            <LinkContainer to="/admin/users">
                                                <NavDropdown.Item>Users</NavDropdown.Item>
                                            </LinkContainer>

                                        </NavDropdown>
                                    )}
                                </Nav>
                            </Navbar.Collapse>

                        </Container>
                    </Navbar>

                </header>

                <div className={
                    sidebarIsOpen
                        ? 'active-nav side-navbar d-flex justify-content-between flex-wrap flex-column'
                        : 'side-navbar d-flex justify-content-between flex-wrap flex-column'
                }>
                    <Nav className="flex-column text-white w-100 p-2">
                        <Nav.Item>
                            <strong>Categories</strong>
                        </Nav.Item>
                        {categories.map((category) => (
                            <Nav.Item key={category}>
                                <LinkContainer
                                    to={{ pathname: '/search', search: `?category=${category}` }}
                                    onClick={() => setSideBarIsOpen(false)}
                                >
                                    <Nav.Link>{category}</Nav.Link>
                                </LinkContainer>
                            </Nav.Item>
                        ))}
                    </Nav>
                </div>

                <main>
                    <Container className='mt-3'>
                        <Routes>
                            <Route path="/" element={<HomeScreen />} />
                            <Route path="/product/:slug" element={<ProductScreen />} />
                            <Route path="/signin" element={<SigninScreen />} />
                            <Route path="/signup" element={<SignupScreen />} />
                            <Route path="/shipping" element={<ShippingAddressScreen />} />
                            <Route path="/payment" element={<PaymentMethodScreen />} />
                            <Route path="/cart" element={<CartScreen />} />
                            <Route path="/search" element={<SearchScreen />} />
                            <Route path="/placeorder" element={<PlaceOrderScreen />} />


                            {/*admin routes*/}
                            <Route path="/admin/dashboard" element={<AdminRoute><DashboardScreen /></AdminRoute>} />

                            <Route path="/order/:id" element={
                                <ProtectedRoute>
                                    <OrderScreen />
                                </ProtectedRoute>
                            } />

                            <Route path="/orderhistory" element={
                                <ProtectedRoute>
                                    <OrderHistoryScreen />
                                </ProtectedRoute>
                            } />

                            <Route path="/profile" element={
                                <ProtectedRoute>
                                    <ProfileScreen />
                                </ProtectedRoute>
                            } />

                            <Route
                                path="/admin/products"
                                element={
                                    <AdminRoute>
                                        <ProductListScreen />
                                    </AdminRoute>
                                }
                            ></Route>

                            <Route
                                path="/admin/users"
                                element={
                                    <AdminRoute>
                                        <UserListScreen />
                                    </AdminRoute>
                                }
                            ></Route>

                            <Route
                                path="/admin/user/:id"
                                element={
                                    <AdminRoute>
                                        <UserEditScreen />
                                    </AdminRoute>
                                }
                            ></Route>

                            <Route
                                path="/admin/orders"
                                element={
                                    <AdminRoute>
                                        <OrderListScreen />
                                    </AdminRoute>
                                }
                            ></Route>

                            <Route
                                path="/admin/product/:id"
                                element={
                                    <AdminRoute>
                                        <ProductEditScreen />
                                    </AdminRoute>
                                }
                            ></Route>

                        </Routes>
                    </Container>
                </main>

                <footer>
                    <div className="text-center">
                        eBay@2024 <br />  All rights reserved
                    </div>
                </footer>
            </div >
        </BrowserRouter >
    );
}

export default App;
